import { Controller } from "@hotwired/stimulus"
import placekitAutocomplete from '@placekit/autocomplete-js';

// Connects to data-controller="placekit-address"
export default class extends Controller {
  static values = { apiKey: String }
  static targets = ["searchInput", "cityField","postalCodeField"];

  connect() {
    const pka = placekitAutocomplete(this.apiKeyValue, {
      target: this.searchInputTarget,
      countries: ['DE'],
    })
    pka.on('pick', (value, item, index) => {
      this.cityFieldTarget.value = item.city;
      this.postalCodeFieldTarget.value = item.zipcode;
    })
  }
}
